import { useEffect, useState } from 'react';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import {
  getWeeklyAccountRichText,
  modifyWeeklyAccountRichText,
} from '@op/services';

interface RichTextResp {
  id: number;
  game_id: string;
  start_time: string;
  end_time: string;
  positive_summary: string;
  negative_summary: string;
  neutral_summary: string;
  create_time: string;
  update_time: string;
  task_id: string;
}

interface RichText {
  summary: string;
  summaryCn: string;
  text: string;
  value: summaryType;
}

type summaryType = 'positive_summary' | 'negative_summary' | 'neutral_summary';
type SummaryItemType = { key: summaryType; text: string; textCn: string };

interface Props {
  filter: any;
  gameInfo: any;
}

const summaryOptions: SummaryItemType[] = [
  { key: 'positive_summary', text: 'Positive Side', textCn: '正面' },
  { key: 'negative_summary', text: 'Negative Side', textCn: '负面' },
  { key: 'neutral_summary', text: 'Neutral Side', textCn: '中性' },
];

export function useRichText({ filter, gameInfo }: Props) {
  const [richText, setRichText] = useState<RichText[]>([]);
  const [richTextResp, setRichTextResp] = useState<RichTextResp>();
  const { wrapperCancelRequest, loading } = useCancelRequestHook({
    defaultLoading: true,
  });

  useEffect(() => {
    if (!filter) return;

    setRichText([]);
    wrapperCancelRequest(getWeeklyAccountRichText, {
      ...gameInfo,
      end_time: filter.end_time,
      start_time: filter.start_time,
    })
      .then((data: RichTextResp) => {
        const richTextList = summaryOptions.map(
          ({ key, text, textCn }: SummaryItemType) => ({
            text,
            value: key,
            summary: data[key],
            summaryCn: data[key],
            textCn,
          }),
        );

        setRichTextResp(data);
        setRichText(richTextList);
      })
      .catch(console.error);
  }, [filter]);

  function modifyRichText(params: any) {
    return modifyWeeklyAccountRichText({ data: params })
      .then(() => true)
      .catch(() => false);
  }

  return {
    richText,
    setRichText,
    richTextResp,
    modifyRichText,
    loading,
  };
}
